import { createCustomFocusIndicatorStyle, makeStyles, tokens } from "@fluentui/react-components";
import { flexParent } from "@ms/planner-generic-controls/lib/local/utilities/Mixin.styles";
export const useSensitivityButtonStyles = makeStyles({
    sensitivityButton: {
        padding: `${tokens.spacingVerticalXS} ${tokens.spacingHorizontalXS}`,
        borderRadius: `${tokens.borderRadiusLarge}`,
        position: "relative",
        ...createCustomFocusIndicatorStyle({
            boxShadow: "none"
        }),
        minWidth: "28px",
        // This is required to render focus on iOS
        ":focus-visible": {
            outlineColor: tokens.colorStrokeFocus2,
            outlineStyle: "solid",
            outlineRadius: tokens.borderRadiusLarge,
            outlineWidth: "2px",
            outlineOffset: "-2px"
        }
    },
    wrapper: {
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
        minWidth: "32px"
    },
    buttonWrapper: {
        overflow: "hidden",
        display: "flex"
    },
    sensitivityButtonIcon: {
        margin: `${tokens.spacingVerticalNone} ${tokens.spacingHorizontalNone}`
    },
    tooltipContainer: {
        borderRadius: tokens.borderRadiusXLarge,
        boxShadow: tokens.shadow16
    },
    tooltipWrapper: {
        ...flexParent("column"),
        alignItems: "center",
        maxWidth: "210px",
        gap: tokens.spacingVerticalL
    },
    tooltipTitle: {
        alignSelf: "start"
    },
    menuPopover: {
        width: "248px !important"
    }
});
export const useSensitivityDialogStyles = makeStyles({
    dialog: {
        maxWidth: "600px",
        backgroundColor: tokens.colorNeutralBackground2
    },
    dialogContent: {
        padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalNone}`
    },
    messageContainer: {
        paddingBottom: tokens.spacingVerticalL
    },
    inputContainer: {
        ...flexParent("column"),
        gap: tokens.spacingVerticalXS
    },
    radioGroup: {
        gap: tokens.spacingVerticalXS
    },
    textInput: {
        width: "100%",
        backgroundColor: tokens.colorNeutralBackground3
    },
    dialogButton: {
        borderRadius: tokens.borderRadiusXLarge,
        minWidth: "auto"
    }
});
